import React, {useEffect, useState} from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router";
import SwiperSlider from "../../../components/elements/slider/SwiperSlider";
import BannerSliderItem from "../components/BannerItem";
import {connect, setStore} from "trim-redux";

function BannersLoader({classes,setting,position}){
    const { t } = useTranslation();
    let { slug } = useParams();
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/front/banners/${position}`,config)
            .then(response => {
                setBanners(response.data);
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
            });
    }

    useEffect(() => {
        loadData();
    },[]);

    return (
        <>
            {
                banners.length > 0 &&
                <SwiperSlider
                    data={banners}
                    spaceBetween={20}
                    slidesPerView={1}
                    showNavigation={true}
                    showPagination={false}
                    //disablePaginationOnMobile={true}
                    //disableNavigationOnMobile={true}
                    autoplay={false}
                    autoplaySpeed={3000}
                    loop={false}
                    renderSlide={(banner) => <BannerSliderItem banner={banner} />}
                />
            }
        </>
    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(BannersLoader));
